<div class="fix-title-row">
  <h3>{{ title }}</h3>
  <div *ngIf="showfix">
    <p-checkbox label="fixieren" [(ngModel)]="isFixed"  binary="true" (onChange)="onFixedChanged()" pTooltip="Bezeichnungs-Spalten werden fixiert. Zeilen müssen auf feste Höhe umgestellt werden. Die Höhe kann über +/- angepasst werden."></p-checkbox>
    <button pButton type="button" icon="fa ui-icon-add-circle-outline" class="dsvs-btn-tool ui-button-round" (click)="onColHeightChange('up')" [disabled]="!isFixed" pTooltip="Zeilenhöhe vergrößern"></button>
    <button pButton type="button" icon="fa ui-icon-remove-circle-outline" class="dsvs-btn-tool ui-button-round" (click)="onColHeightChange('down')" [disabled]="!isFixed" pTooltip="Zeilenhöhe verkleinern"></button>
  </div>
</div>
